<template>

    <div class="filter"> 
        <Select v-model="siteInput"
            :options="siteOptions"
            all="Tous les sites"
            autocomplete>
        </Select>
    </div>

</template>

<script>
import Select  from '@/components/select/Select.vue'

export default {

    props: {
        
        clientAddresses: {
            type: Array,
            default: () => []
        },

        markets: {
            type: Array,
            default: () => []
        },

        disabled: {
            type: Boolean,
            default: false
        },

        value: {
            default: null
        }
    },

    computed: {

        siteInput: {

            get: function() {
                return this.value;
            },

            set: function(value){
                this.$emit('input', value)
            }
        },

        siteOptions: function() {
            let siteOptions = []
            this.clientAddresses.forEach(clientAddress => {
                siteOptions.push({
                    value: clientAddress.site.id,
                    name: clientAddress.label
                })
            })
            this.markets.forEach(market => {
                siteOptions.push({
                    value: market.site.id,
                    name: market.label
                })
            })
            return siteOptions
        }
    },

    components: {
        Select
    }
}

</script>

<style scoped>

@media screen and (min-width: 800px) {

    .select {
        min-width: 25rem;
    }
}

</style>